module.exports = __webpack_public_path__ + "img/tussam_progetto.4fd5475c.png";